import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';
import { LoadingSpinner } from './components/spinners/index';
import './styles/globals.css';
import { ServiceWorkerProvider } from './providers/service-worker-provider';
import { NewVersionToasterProvider } from './providers/new-version-toaster-provider';
import { BugsnagProvider } from './providers/bugsnag-provider';
import {
  LIST_CACHE_TIME,
  LIST_STALE_TIME,
} from './shared/constants/react-query';

const lazyWithRetry = <T extends React.ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
) => {
  return React.lazy(async () => {
    try {
      return await factory();
    } catch (error: any) {
      const chunkFailedMessage = /Loading chunk [\d]+ failed/;

      if (chunkFailedMessage.test(error?.message)) {
        if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
          navigator.serviceWorker
            .getRegistrations()
            .then((registrations) => {
              registrations.forEach((registration) => {
                registration.unregister();
              });
            })
            .finally(() => {
              window.location.reload();
            });
        } else if (typeof window !== 'undefined') {
          window.location.reload();
        }
      }

      throw error;
    }
  });
};

const Routes = lazyWithRetry(() => import('./routes'));

export const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      retry: 5,
      retryDelay: 1000,
    },
    queries: {
      retry: 5,
      retryDelay: 1000,
      staleTime: LIST_STALE_TIME,
      cacheTime: LIST_CACHE_TIME,
    },
  },
});

function App() {
  return (
    <>
      <ServiceWorkerProvider>
        <Toaster
          position="top-center"
          reverseOrder={false}
          containerStyle={{
            zIndex: 9999999,
          }}
          toastOptions={{
            error: {
              style: {
                border: '2px solid #c53030',
              },
            },
          }}
        />
        <BrowserRouter>
          <BugsnagProvider>
            <NewVersionToasterProvider>
              <QueryClientProvider client={queryClient}>
                <React.Suspense
                  fallback={<LoadingSpinner position="absolute" size="large" />}
                >
                  <Routes />
                </React.Suspense>
              </QueryClientProvider>
            </NewVersionToasterProvider>
          </BugsnagProvider>
        </BrowserRouter>
        {/* <NewVersionToasterProvider>
          <QueryClientProvider client={queryClient}>
            <React.Suspense
              fallback={<LoadingSpinner position="absolute" size="large" />}
            >
              <BrowserRouter>
                <BugsnagProvider>
                  <Routes />
                </BugsnagProvider>
              </BrowserRouter>
            </React.Suspense>
          </QueryClientProvider>
        </NewVersionToasterProvider> */}
      </ServiceWorkerProvider>
    </>
  );
}

export default App;
